import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

// Styled components
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: "8px",
    backgroundColor: "#fff",
    '&:hover': {
        backgroundColor: "#f1f1f1",
    },
    marginLeft: 0,
    [theme.breakpoints.up('md')]: {
        width: '400px',
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));

const SearchIconWrapper = styled('div', {
    shouldForwardProp: (prop) => prop !== 'focused',
})(({ theme, focused }) => ({
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    left: 0,
    color: focused ? "#3E4094" : "#a1a1a1",
    transition: theme.transitions.create(['border-color', 'color']),
}));

const ClearIconWrapper = styled('div')({
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    zIndex: 2,
    padding: '0 10px',
    color: '#a1a1a1',
    '&:hover': {
        color: '#000',
    }
});

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "#000",
    width: '100%',
    '& .MuiInputBase-input': {
        padding: "12px 40px",
        border: `1px solid #c4c4c4`,
        borderRadius: '8px',
        backgroundColor: "#fff",
        transition: theme.transitions.create(['border-color']),
        '&::placeholder': {
            color: "#111",
        },
    },
    '& .MuiInputBase-input:focus': {
        borderColor: "#3E4094",
        outline: 'none',
    },
}));

const CommonSearch = ({ 
    placeholder, 
    handleSearch, 
    onInputChange,
    debounceInterval = 500 
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [timer, setTimer] = useState(null);
    const [focused, setFocused] = useState(false);

    const handleSearchChange = (ev) => {
        const value = (ev.target.value || '').trim();
        setSearchTerm(value);
        
        if (timer) {
            clearTimeout(timer);
        }
        
        const newTimer = setTimeout(() => {
            handleSearch && handleSearch(value);
        }, debounceInterval);
        
        setTimer(newTimer);
        onInputChange && onInputChange(value);
    };

    const handleClear = () => {
        setSearchTerm('');
        handleSearch && handleSearch('');
        onInputChange && onInputChange('');
    };

    return (
        <Search>
            <SearchIconWrapper focused={focused}>
                <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
                value={searchTerm}
                placeholder={placeholder || 'Search here...'}
                inputProps={{ 'aria-label': 'search' }}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onChange={handleSearchChange}
            />
            {searchTerm && (
                <ClearIconWrapper onClick={handleClear}>
                    <ClearIcon fontSize="small" />
                </ClearIconWrapper>
            )}
        </Search>
    );
};

export default CommonSearch;